import React from "react";
import {
    Container,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Stack
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faChevronDown, faQuestionCircle} from "@fortawesome/free-solid-svg-icons";
import SectionTitle from "@others/title-section.layout";

const faqData = [
    {
        question: "Comment puis-je participer à une enquête proposée sur le site ?",
        answer:
            "Pour participer à une enquête, il vous suffit de vous rendre dans la rubrique « Espace Écoute des Habitants », de sélectionner l’enquête qui vous intéresse, puis de cliquer sur le bouton « Je participe ! ». Suivez ensuite les instructions à l’écran."
    },
    {
        question: "Mes réponses aux sondages sont-elles anonymes ?",
        answer:
            "Oui, toutes les réponses aux sondages sont traitées de façon anonyme. Nous attachons beaucoup d’importance à la confidentialité de vos réponses pour garantir leur sincérité."
    }
];

const FaqPage: React.FC = () => (
    <Container sx={{ pb: 6 }}>
        <SectionTitle title={"FOIRE AUX QUESTIONS"} />
        <Box mt={4} mb={4}>
            <Stack direction="row" spacing={2} alignItems="center" mb={3}>
                <FontAwesomeIcon icon={faQuestionCircle} size="2x" style={{ color: "#1976d2" }} />
                <Typography variant="h5" fontWeight={700} color="primary">
                    Foire aux questions
                </Typography>
            </Stack>
            {faqData.map((faq, idx) => (
                <Accordion key={idx} sx={{ mb: 2, borderRadius: 2, overflow: "hidden", boxShadow: 2 }}>
                    <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={faChevronDown} style={{ color: "#1976d2", fontSize: 20 }} />}
                        aria-controls={`faq-content-${idx}`}
                        id={`faq-header-${idx}`}
                    >
                        <Typography variant="subtitle1" fontWeight={600} color="primary">
                            {faq.question}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ bgcolor: "#f5fafd" }}>
                        <Typography variant="body2" color="text.secondary">
                            {faq.answer}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    </Container>
);

export default FaqPage;